import { render, staticRenderFns } from "./RenovationBill.vue?vue&type=template&id=238d4e02&scoped=true"
import script from "./RenovationBill.vue?vue&type=script&lang=js"
export * from "./RenovationBill.vue?vue&type=script&lang=js"
import style0 from "./RenovationBill.vue?vue&type=style&index=0&id=238d4e02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d4e02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238d4e02')) {
      api.createRecord('238d4e02', component.options)
    } else {
      api.reload('238d4e02', component.options)
    }
    module.hot.accept("./RenovationBill.vue?vue&type=template&id=238d4e02&scoped=true", function () {
      api.rerender('238d4e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billManage/billList/components/RenovationBill.vue"
export default component.exports